<template>
  <svg-icon name="Msg-Error" size="16px"></svg-icon>
</template>
